module.exports = __webpack_public_path__ + "img/icon_instagram.9bd2e2f5.svg";